import { eachDay } from 'date-fns'

export default {
    methods: {
        currentWeekDateRange() {
            let now = new Date()
            let startDay = new Date(now.setDate(now.getDate() - now.getDay() + (now.getDay() == 0 ? -6 : 1)))

            return this.generateWeekRange(startDay)
        },
        generateWeekRange(startDay) {
            let weekRange = eachDay(
                new Date(startDay.getFullYear(), startDay.getMonth(), startDay.getDate() + 1),
                new Date(startDay.getFullYear(), startDay.getMonth(), startDay.getDate() + 7)
            ).map(item => JSON.stringify(item).slice(1, 11))

            return weekRange
        },
        generate2CharWeekday(date) {
            const weekdays2char = ['nd', 'pn', 'wt', 'śr', 'cz', 'pt', 'sb']

            return weekdays2char[new Date(date).getDay()]
        }
    }
}